import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicCosmeticCharacteristicResponse } from './public-cosmetic-characteristic.response';
import { PublicCosmeticAttributeResponse } from './public-cosmetic-attribute.response';
import { PublicCosmeticBrandResponse } from './public-cosmetic-brand.response';
import { PublicCosmeticBoxResponse } from './public-cosmetic-box.response';

@jsonObject
export class PublicCosmeticDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly vendorUrl?: Nillable<string>;

  @jsonMember(PublicCosmeticBrandResponse)
  public readonly cosmeticBrand!: PublicCosmeticBrandResponse;

  @jsonArrayMember(MultimediaResponse)
  public readonly files!: MultimediaResponse[];

  @jsonArrayMember(PublicCosmeticCharacteristicResponse)
  public readonly characteristics!: PublicCosmeticCharacteristicResponse[];

  @jsonArrayMember(PublicCosmeticAttributeResponse)
  public readonly attributes!: PublicCosmeticAttributeResponse[];

  @jsonMember(PublicCosmeticBoxResponse)
  public readonly box?: Nillable<PublicCosmeticBoxResponse>;
}
